import { useEffect, useState } from 'react';

// Tailwind md(768px)와 동일 기준 — CSS `md:` 분기와 JS 분기가 어긋나지 않도록 이 훅만 사용할 것
const MOBILE_QUERY = '(max-width: 767px)';

/**
 * 지금 화면 폭이 768px 미만인가 — 렌더 밖(useState 초기값 등)에서 동기로 읽을 때 쓴다.
 * ⚠ "좁다"일 뿐 "모바일 배치"가 아니다. PC앱(Tauri)은 좁아져도 모바일 배치 대신 컴팩트 배치를 쓴다
 * (App.tsx의 isMobile / isCompactDesktop).
 */
export function isMobileViewport(): boolean {
  return window.matchMedia(MOBILE_QUERY).matches;
}

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(isMobileViewport);

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return isMobile;
}
